import { isClient } from "@kikoff/utils/src/general";

if (isClient && process.env.REALLY_PRODUCTION) {
  // @ts-expect-error
  // eslint-disable-next-line
  (function(w, d){ var id='pdst-capture', n='script';if (!d.getElementById(id)) { w.pdst = w.pdst ||function() {(w.pdst.q = w.pdst.q || []).push(arguments);};var e = d.createElement(n); e.id = id; e.async=1;e.src = 'https://cdn.pdst.fm/ping.min.js';var s = d.getElementsByTagName(n)[0];s.parentNode.insertBefore(e, s);} w.pdst('conf', { key: '56b67400dc3d49efa0cf7dbb7ffcf23b' }); w.pdst('view'); })(window, document);
}
